export default __webpack_public_path__ + "static/media/icon_calendar_important.c796819c.svg";